import styled, { keyframes } from "styled-components";
import { Link } from "react-router";

export const Background = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   background-color: #cbb9d9;
`
export const Header1 = styled.h1`
    font-family: 'Kinkee';
    font-size: 4rem;
    color: #794b9c;
    text-align: center;
    @media (max-width: 767px) {
        font-size: 3rem;
    }
    
`
export const SubContainer = styled.div`
    
`
export const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    
`
export const TVChannelContainer = styled.div`
    max-width: 50%;
    align-self: center;
    justify-self: center;
`

export const TV = styled.div`
    display: flex;
    background: transparent;
    justify-content: center;
    align-items: center;
`

export const PageLink = styled(Link)`
    text-decoration: none;
    color: #794b9c;
    &:active {
        color: #514B9C;
    }
    &:hover {
        color: #9C4B97;
    }
   
    
`
export const GeneralLinks = styled.a`
    text-decoration: none;
    color: #794b9c;
    &:active {
        color: #514B9C;
    }
    &:hover {
        color: #9C4B97;
    }
`
export const TestImg = styled.img`
    position: absolute;
    width: 60%;
    z-index: 3;
    
`
export const TVDisplay = styled.img`
    position: relative;
    width: 42%;
    z-index: 3;
    @media (max-width: 767px) {
        width: 60%;
    }
`
export const TVDisplayLogo = styled.img`
    position: relative;
    align-self: center;
    width: 30%;

    z-index: 3;
`
export const TVImage =styled.img`
    position:absolute;
    align-self: center;
    justify-self: center;
    margin: auto;
    width: 50%;
    z-index: 4;
    @media (max-width: 767px) {
        width: 70%;
    }
`
export const ImgGIF = styled.img`
    visibility: hidden;
    max-width: 0;
    overflow: hidden;
    display: none;
    
    
`
export const RemoteImg = styled.img`
    
`
export const Gradient = styled.div`
    background: linear-gradient(#f1a9ca, #cbb9d9);
    min-height: 150px;
    @media (max-width: 767px) {
        min-height: 100px;
    }
`
export const GrowAnim = keyframes`
     0% {
        
 
    }
    100% {
       transform: scale(1.25);
    }
`


export const Play = styled.img`
    align-self: center;
    max-width: 30px;
    padding-left: 20px;
    &:hover{
        animation-name: ${GrowAnim};
        animation-duration: 500ms;
        animation-fill-mode: forwards;
    }
`


export const GifContainer = styled.div`
   display: flex;
   justify-content: space-between;
`
export const AnimationIn= keyframes`
    0% {
        visibility: hidden;
        max-width: 0;
        overflow: hidden;
        margin-left: auto;
        margin-right: auto;
 
    }
    100% {
        visibility: visible;
        max-width: 100%;
        overflow: inherit;
        display: inline;
        margin-left: auto;
        margin-right: auto;
    
    }
`

export const AnimationOut= keyframes`
    0% {
        
        visibility: visible;
        max-width: 100%;
        overflow: inherit;
        display: inline;
        margin-left: auto;
        margin-right: auto;
 
    }
    100% {
        visibility: hidden;
        max-width: 0;
        overflow: hidden;
        margin-left: auto;
        margin-right: auto;

    }
`

export const Header2 = styled.h2`
    display: block;
    text-align: center;
    font-family: 'GirlOnTheAlley';
    

    +${ImgGIF}{
        animation-name: ${AnimationOut};
        animation-duration: 1s;
        animation-fill-mode: forwards;
        display: none;
    }
     &:hover +${ImgGIF}{
        animation-name: ${AnimationIn};
        animation-duration: 1s;
        animation-fill-mode: forwards;
        display: block;
        
    }
    
`
export const OppGradient = styled.div`
    background: linear-gradient(#cbb9d9, #f1a9ca);
    min-height: 200px;
    @media (max-width: 767px) {
        min-height: 100px;
    }
`

